import { POOL_TYPES } from "@teamrota/rota-common";

export const mergeBookingUpdates = ({ bookings, bookingUpdates }) => {
  const updateMap = Object.fromEntries(
    bookingUpdates.map(bookingUpdate => [`${bookingUpdate.id}`, bookingUpdate])
  );

  const bookingApprovals = bookings.map(({ booking, member }) => {
    const id = `${booking.id}`;

    const original = {
      id,
      startOnApproval: booking?.startFinal,
      endOnApproval: booking?.endFinal,
      breakOnApproval: booking?.breakFinal || 0,
      ratingOfMember: booking?.ratingOfMember,
      feedbackForMember: booking?.feedbackForMember,
      feedbackLabelsForMember: booking?.feedbackLabelsForMember,
      isFavourited: member?.poolType === POOL_TYPES.FAVOURITED,
      notes: booking?.notes,
      isNoShow: booking?.isNoShow,
      isTurnedAway: booking?.isTurnedAway
    };

    const approval = updateMap[id]
      ? { ...original, ...updateMap[id] }
      : original;

    return approval;
  });

  return bookingApprovals;
};

export const validateApprovals = ({
  bookingApprovals,
  isApprovingShift,
  isRatingRequired,
  isTTM = false
}) => {
  let error = "";

  // check each booking has the required fields or that it's been updated

  bookingApprovals.forEach(approval => {
    if (
      !approval.ratingOfMember &&
      !approval.isNoShow &&
      !approval.isTurnedAway &&
      isApprovingShift &&
      isRatingRequired
    ) {
      error = "Please check that you have rated all members";
    } else if (
      approval.ratingOfMember <= 2 &&
      approval.ratingOfMember !== null &&
      isRatingRequired
    ) {
      if (
        !approval.feedbackLabelsForMember?.length &&
        !approval.feedbackForMember &&
        !approval.isNoShow &&
        !approval.isTurnedAway &&
        isRatingRequired &&
        !isTTM
      ) {
        error =
          "You must provide feedback for all Members rated two stars or less";
      }
    } else if (approval.isTurnedAway && !approval.notes) {
      error =
        'Please check you have given a reason to all members marked as "Turned away"';
    }
  });

  return error;
};
